/* eslint-disable indent */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { Logger, LoggerTypes } from './utils'
// import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  // -- load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // -- learn more: https://github.com/i18next/i18next-http-backend
  // -- want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)

  // -- detect user language
  // -- learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)

  // -- pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // -- for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: false,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    initImmediate: false,
    react: {
      useSuspense: false,
      hashTransKey: function (defaultValue) {
        Logger.trace(LoggerTypes.WARN, 'i18n.react.hashTransKey()', { defaultValue })
        return defaultValue
      },
      defaultTransParent: 'div', // a valid react element - required before react 16
      transEmptyNodeValue: '', // what to return for empty Trans
      transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'], // don't convert to <1></1> if simple react elements
      transWrapTextNodes: '' // Wrap text nodes in a user-specified element.
      // i.e. set it to 'span'. By default, text nodes are not wrapped.
      // Can be used to work around a well-known Google Translate issue with React apps. See: https://github.com/facebook/react/issues/11538
      // (v11.10.0)
    }
  })

export default i18n
